import { HelperConstant } from '../../helpers/HelperConstant';
import { useTypedDispatch } from 'features/reduxhooks/ReduxHooks';
import React, { InputHTMLAttributes, useEffect, useState } from 'react'
import CommonService from 'services/CommonService';
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { Card, CardBody, CardHeader, Col, Label, Row } from 'reactstrap';
import { CustomButton } from 'components/shared/CustomButton';
import { pageChange } from 'features/reducers/DocumentScan/PageChange.Reducer';
import { isMobile } from '../../helpers/Helper';

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    statusId: any;
    ProductTypeName?: any,
    encryptedOrderId: any,
    activeTab: any,
    setActiveTab: any
}


function UploadImage({ statusId, ProductTypeName, encryptedOrderId, activeTab, setActiveTab, ...rest }: inputProps, ref) {

    let dispatch = useTypedDispatch();

    const [imageSelfie, setImageSelfie] = useState<any>();
    const [imageIdproofFront, setIdproofFront] = useState<any>();
    const [imageIdproofBack, setIdproofBack] = useState<any>();
    const [imageBill, setImageBill] = useState<any>();
    const [imagewarranty, setImagewarranty] = useState<any>();
    const [ImageTop, setImageTop] = useState<any>();
    const [ImageBottom, setImageBottom] = useState<any>();
    const [ImageLeft, setImageLeft] = useState<any>();
    const [ImageRight, setImageRight] = useState<any>();
    const [ImageBack, setImageBack] = useState<any>();
    const [ImageFront, setImageFront] = useState<any>();
    const [showEdit, setShowEdit] = useState(true);
    const [DataToDisplay, setDataToDisplay] = useState("")

    const [orders, setOrders] = useState<Array<any>>([]);

    const uploadImage = (imageFile: any, documentTypeIdData: any) => {
        let formData = new FormData();

        formData.append("OrdersId", "0");
        formData.append("DocumentTypeId", documentTypeIdData);
        formData.append("DocumentPath", "");
        formData.append("RowOrder", "100");
        formData.append("UploadFiles", imageFile);
        formData.append("FileName", imageFile.name);
        formData.append("Specifics", "10");

        CommonService.postWithFormDataWithQueryParam('OrderDocuments', 'AddOrderDocument', formData, "encryptedOrderId", encryptedOrderId, "multipart/form-data").then((res) => {
            if (res.status === 200) {
            }
        }).catch(e => console.log(e));
    };

    const [photostype] = useState({
        selfie: "Selfie.png",
        IdproofFront: "Id_Front.png",
        IproofBack: "Id_Back.png",
        Bill: "Bill.png",
        warranty: "Warranty.png",
        Top: "Top.png",
        Bottom: "Bottom.png",
        Left: "Left.png",
        Right: "Right.png",
        Back: "back.png",
        Front: "Front.png"
    });

    const [DocumentType] = useState({
        selfie: HelperConstant.documentTypeId.Selfie,
        IdproofFront: HelperConstant.documentTypeId.Id_Front,
        IdproofBack: HelperConstant.documentTypeId.Id_Back,
        Bill: HelperConstant.documentTypeId.Bill,
        warranty: HelperConstant.documentTypeId.Warranty,
        Top: HelperConstant.documentTypeId.Top,
        Bottom: HelperConstant.documentTypeId.Bottom,
        Left: HelperConstant.documentTypeId.Left,
        Right: HelperConstant.documentTypeId.Right,
        Back: HelperConstant.documentTypeId.Back,
        Front: HelperConstant.documentTypeId.Front,
    });

    const takePicture = async (photostypes: any, documentTypeIdData: any) => {
        const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.DataUrl,
            source: CameraSource.Camera
        }).catch((e) => {
            console.log(e);
            throw new Error(e);
        });

        const dataURLtoFile = (dataurl: any, filename: string) => {
            let arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        };


        const imageFile = dataURLtoFile(image.dataUrl, photostypes);
        const UploadFiles: any = image.dataUrl;

        if (photostypes === photostype.selfie && documentTypeIdData === DocumentType.selfie) {
            uploadImage(imageFile, documentTypeIdData);
            setImageSelfie(UploadFiles)
        }
        if (photostypes === photostype.IdproofFront && documentTypeIdData === DocumentType.IdproofFront) {
            uploadImage(imageFile, documentTypeIdData);
            setIdproofFront(UploadFiles)
        }
        if (photostypes === photostype.IproofBack && documentTypeIdData === DocumentType.IdproofBack) {
            uploadImage(imageFile, documentTypeIdData);
            setIdproofBack(UploadFiles)
        }
        if (photostypes === photostype.Bill && documentTypeIdData === DocumentType.Bill) {
            uploadImage(imageFile, documentTypeIdData);
            setImageBill(UploadFiles)
        }
        if (photostypes === photostype.warranty && documentTypeIdData === DocumentType.warranty) {
            uploadImage(imageFile, documentTypeIdData);
            setImagewarranty(UploadFiles);
        }
        if (photostypes === photostype.Top && documentTypeIdData === DocumentType.Top) {
            uploadImage(imageFile, documentTypeIdData);
            setImageTop(UploadFiles);
        }
        if (photostypes === photostype.Bottom && documentTypeIdData === DocumentType.Bottom) {
            uploadImage(imageFile, documentTypeIdData);
            setImageBottom(UploadFiles);
        }
        if (photostypes === photostype.Left && documentTypeIdData === DocumentType.Left) {
            uploadImage(imageFile, documentTypeIdData);
            setImageLeft(UploadFiles);
        }
        if (photostypes === photostype.Right && documentTypeIdData === DocumentType.Right) {
            uploadImage(imageFile, documentTypeIdData);
            setImageRight(UploadFiles);
        }
        if (photostypes === photostype.Front && documentTypeIdData === DocumentType.Front) {
            uploadImage(imageFile, documentTypeIdData);
            setImageFront(UploadFiles);
        }
        if (photostypes === photostype.Back && documentTypeIdData === DocumentType.Back) {
            uploadImage(imageFile, documentTypeIdData);
            setImageBack(UploadFiles);
        }
    };

    const deleteImage = (documentTypeId: any) => {
        CommonService.postWithDoubleParam('OrderDocuments', 'DeleteOrderDocument', 'orderId', encryptedOrderId, 'documentTypeId', documentTypeId).then(
            (res) => {
                if (DocumentType.selfie === documentTypeId) {
                    setImageSelfie("");
                }
                if (DocumentType.IdproofFront === documentTypeId) {
                    setIdproofFront("");
                }
                if (DocumentType.IdproofBack === documentTypeId) {
                    setIdproofBack("");
                }
                if (DocumentType.Bill === documentTypeId) {
                    setImageBill("");
                }
                if (DocumentType.warranty === documentTypeId) {
                    setImagewarranty("");
                }
                if (DocumentType.Top === documentTypeId) {
                    setImageTop("");
                }
                if (DocumentType.Bottom === documentTypeId) {
                    setImageBottom("");
                }
                if (DocumentType.Left === documentTypeId) {
                    setImageLeft("");
                }
                if (DocumentType.Right === documentTypeId) {
                    setImageRight("");
                }
                if (DocumentType.Front === documentTypeId) {
                    setImageFront("");
                }
                if (DocumentType.Back === documentTypeId) {
                    setImageBack("");
                }
            }
        );
    };
    useEffect(() => {
        const GetDisplayDocuments = () => {
            CommonService.postWithQueryParam('OrderDocuments', 'GetOrderDocuments', 'orderId', encryptedOrderId, "application/json").then((response) => {
                if (response.status === 200) {
                    setOrders(response.data);
                    if ((statusId === HelperConstant.StatusId.CANCELLED || statusId === HelperConstant.StatusId.COMPLETED || statusId === HelperConstant.StatusId.FAILED) && response?.data?.length > 0) {
                        setShowEdit(false);
                    }
                    setDataToDisplay("ok")
                    for (const res of orders) {
                        const documentTypeIdData = res.DocumentTypeId;
                        CommonService.postWithDoubleParam('OrderDocuments', 'GetBase64OrderDocument', 'orderId', encryptedOrderId, 'documentTypeId', documentTypeIdData).then((res) => {
                            if (res.status === 200) {
                                let base64ImageString: any = `data:image/png;base64,${res.data}`;
                                if (DocumentType.selfie === documentTypeIdData) {
                                    setImageSelfie(base64ImageString);
                                }
                                if (DocumentType.IdproofFront === documentTypeIdData) {
                                    setIdproofFront(base64ImageString);
                                }
                                if (DocumentType.IdproofBack === documentTypeIdData) {
                                    setIdproofBack(base64ImageString);
                                }
                                if (DocumentType.Bill === documentTypeIdData) {
                                    setImageBill(base64ImageString);
                                }
                                if (DocumentType.warranty === documentTypeIdData) {
                                    setImagewarranty(base64ImageString);
                                }
                                if (DocumentType.Top === documentTypeIdData) {
                                    setImageTop(base64ImageString);
                                }
                                if (DocumentType.Bottom === documentTypeIdData) {
                                    setImageBottom(base64ImageString);
                                }
                                if (DocumentType.Left === documentTypeIdData) {
                                    setImageLeft(base64ImageString);
                                }
                                if (DocumentType.Right === documentTypeIdData) {
                                    setImageRight(base64ImageString);
                                }
                                if (DocumentType.Front === documentTypeIdData) {
                                    setImageFront(base64ImageString);
                                }
                                if (DocumentType.Back === documentTypeIdData) {
                                    setImageBack(base64ImageString);
                                }
                            }
                        }).catch(e => {
                            console.log(e);
                        });
                    }
                }
            }).catch(e => {
                console.log(e);
            });
        };
        GetDisplayDocuments();
    }, [DataToDisplay]);

    return (
        <React.Fragment>
            <Card className='p-0'>
                <CardBody>
                    <div className='mb-2'>
                        <i className='fas fa-hashtag text-dofy me-2 font-size-15'></i>
                        <span className='font-size-16 fw-semibold text-dofy'>Image Upload Section</span>
                    </div>
                    <Row>
                        <p className='text-dark font-size-14 fw-semibold'>Customer Details</p>
                        <Col xl={3} className=''>
                            {imageIdproofFront ?
                                <Card className='bg-light p-2'>

                                    <img className="ui-image" src={imageIdproofFront} alt="" />
                                    <div className='mt-2 d-flex justify-content-between align-items-center'>
                                        <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Id Proof Front</span >
                                        {showEdit ?
                                            <i className='mdi mdi-close font-size-18 text-dofy cursor-pointer' onClick={() => deleteImage(DocumentType.IdproofFront)} slot="end" />
                                            : null}
                                    </div>
                                </Card>
                                :
                                <Card className='bg-light cursor-pointer' onClick={() => { takePicture(photostype.IdproofFront, HelperConstant.documentTypeId.Id_Front); }} >
                                    <CardBody className="text-center my-4">
                                        <i className='fas fa-plus text-dofy font-size-24 cursor-pointer'></i>
                                        <p className='m-0 mt-2 font-size-14 text-dofy fw-semibold'>Id Front</p>
                                    </CardBody>
                                </Card>}
                        </Col>
                        <Col xl={3}>
                            {imageIdproofBack ? (
                                <Card className='bg-light p-2'>
                                    <img className="ui-image" src={`${imageIdproofBack}`} alt="" />
                                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                                        <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Id Proof Back</span >
                                        {showEdit ?
                                            <i className='mdi mdi-close font-size-18 text-dofy cursor-pointer' onClick={() => deleteImage(DocumentType.IdproofBack)} slot="end" />
                                            : null}
                                    </div>
                                </Card>

                            ) :
                                <Card className='bg-light cursor-pointer' onClick={() => { takePicture(photostype.IproofBack, HelperConstant.documentTypeId.Id_Back); }}>
                                    <CardBody className="text-center my-4">
                                        <i className='fas fa-plus text-dofy font-size-24 cursor-pointer'></i>
                                        <p className='m-0 mt-2 font-size-12 text-dofy fw-semibold'>Id Back</p>
                                    </CardBody>
                                </Card>}
                        </Col>
                        <Col xl={3}>
                            {imageBill ? (
                                <Card className='bg-light p-2'>
                                    <img className="ui-image" src={`${imageBill}`} alt="" />
                                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                                        <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Bill (Optional)</span >
                                        {showEdit ?
                                            <i className='mdi mdi-close font-size-18 text-dofy cursor-pointer' onClick={() => deleteImage(DocumentType.Bill)} slot="end" />
                                            : null}
                                    </div>
                                </Card>

                            ) :
                                <Card className='bg-light cursor-pointer' onClick={() => { takePicture(photostype.Bill, HelperConstant.documentTypeId.Bill); }}>
                                    <CardBody className="text-center my-4">
                                        <i className='fas fa-plus text-dofy font-size-24 cursor-pointer'></i>
                                        <p className='m-0 mt-2 font-size-12 text-dofy fw-semibold'>Bill (Optional)</p>
                                    </CardBody>
                                </Card>}
                        </Col>
                    </Row>
                    <Row>
                        <p className='text-dark font-size-14 fw-semibold'>Device Details</p>
                        <Col xl={2}>
                            {ImageTop ?
                                <Card className='bg-light p-2'>
                                    <img className="ui-image" src={`${ImageTop}`} alt="" />
                                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                                        <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Top</span >
                                        {showEdit ?
                                            <i className='mdi mdi-close font-size-18 text-dofy cursor-pointer' onClick={() => deleteImage(DocumentType.Top)} slot="end" />
                                            : null}
                                    </div>
                                </Card>
                                :
                                <Card className='bg-light cursor-pointer' onClick={() => { takePicture(photostype.Top, HelperConstant.documentTypeId.Top); }}>
                                    <CardBody className="text-center my-4">
                                        <i className='fas fa-plus text-dofy font-size-24 cursor-pointer'></i>
                                        <p className='m-0 mt-2 font-size-12 text-dofy fw-semibold'>Top</p>
                                    </CardBody>
                                </Card>}
                        </Col>
                        <Col xl={2}>
                            {ImageBottom ? (
                                <Card className='bg-light p-2'>
                                    <img className="ui-image" src={`${ImageBottom}`} alt="" />
                                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                                        <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Bottom</span >
                                        {showEdit ?
                                            <i className='mdi mdi-close font-size-18 text-dofy cursor-pointer' onClick={() => deleteImage(DocumentType.Bottom)} slot="end" />
                                            : null}
                                    </div>
                                </Card>

                            ) :
                                <Card className='bg-light cursor-pointer' onClick={() => { takePicture(photostype.Bottom, HelperConstant.documentTypeId.Bottom); }}>
                                    <CardBody className="text-center my-4">
                                        <i className='fas fa-plus text-dofy font-size-24 cursor-pointer'></i>
                                        <p className='m-0 mt-2 font-size-12 text-dofy fw-semibold'>Bottom</p>
                                    </CardBody>
                                </Card>}
                        </Col>
                        <Col xl={2}>
                            {ImageLeft ? (
                                <Card className='bg-light p-2'>
                                    <img className="ui-image" src={`${ImageLeft}`} alt="" />
                                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                                        <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Left</span >
                                        {showEdit ?
                                            <i className='mdi mdi-close font-size-18 text-dofy cursor-pointer' onClick={() => deleteImage(DocumentType.Left)} slot="end" />
                                            : null}
                                    </div>
                                </Card>

                            ) :
                                <Card className='bg-light cursor-pointer' onClick={() => { takePicture(photostype.Left, HelperConstant.documentTypeId.Left); }}>
                                    <CardBody className="text-center my-4">
                                        <i className='fas fa-plus text-dofy font-size-24 cursor-pointer'></i>
                                        <p className='m-0 mt-2 font-size-12 text-dofy fw-semibold'>Left</p>
                                    </CardBody>
                                </Card>}
                        </Col>
                        <Col xl={2}>
                            {ImageRight ? (
                                <Card className='bg-light p-2'>
                                    <img className="ui-image" src={`${ImageRight}`} alt="" />
                                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                                        <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Right</span >
                                        {showEdit ?
                                            <i className='mdi mdi-close font-size-18 text-dofy cursor-pointer' onClick={() => deleteImage(DocumentType.Right)} slot="end" />
                                            : null}
                                    </div>
                                </Card>

                            ) :
                                <Card className='bg-light cursor-pointer' onClick={() => { takePicture(photostype.Right, HelperConstant.documentTypeId.Right); }}>
                                    <CardBody className="text-center my-4">
                                        <i className='fas fa-plus text-dofy font-size-24 cursor-pointer'></i>
                                        <p className='m-0 mt-2 font-size-12 text-dofy fw-semibold'>Right</p>
                                    </CardBody>
                                </Card>}
                        </Col>
                        <Col xl={2}>
                            {ImageFront ? (
                                <Card className='bg-light p-2'>
                                    <img className="ui-image" src={`${ImageFront}`} alt="" />
                                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                                        <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Front</span >
                                        {showEdit ?
                                            <i className='mdi mdi-close font-size-18 text-dofy cursor-pointer' onClick={() => deleteImage(DocumentType.Front)} slot="end" />
                                            : null}
                                    </div>
                                </Card>

                            ) :
                                <Card className='bg-light cursor-pointer' onClick={() => { takePicture(photostype.Front, HelperConstant.documentTypeId.Front); }}>
                                    <CardBody className="text-center my-4">
                                        <i className='fas fa-plus text-dofy font-size-24 cursor-pointer'></i>
                                        <p className='m-0 mt-2 font-size-12 text-dofy fw-semibold'>Front</p>
                                    </CardBody>
                                </Card>}
                        </Col>
                        <Col xl={2}>
                            {ImageBack ? (
                                <Card className='bg-light p-2'>
                                    <img className="ui-image" src={`${ImageBack}`} alt="" />
                                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                                        <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Back</span >
                                        {showEdit ?
                                            <i className='mdi mdi-close font-size-18 text-dofy cursor-pointer' onClick={() => deleteImage(DocumentType.Back)} slot="end" />
                                            : null}
                                    </div>
                                </Card>

                            ) :
                                <Card className='bg-light cursor-pointer' onClick={() => { takePicture(photostype.Back, HelperConstant.documentTypeId.Back); }}>
                                    <CardBody className="text-center my-4">
                                        <i className='fas fa-plus text-dofy font-size-24 cursor-pointer'></i>
                                        <p className='m-0 mt-2 font-size-12 text-dofy fw-semibold'>Back</p>
                                    </CardBody>
                                </Card>}
                        </Col>
                    </Row>
                    <Row className='mt-1'>
                        <Col>
                            {!isMobile() ?
                                <div className='d-flex justify-content-end'>
                                    <CustomButton type={'button'} btnClassName={'btn-light me-2'} iconClasssName={''} name={'Previous'} onClick={() => { setActiveTab(1); dispatch(pageChange("IMEIPage")) }} />
                                    <CustomButton disabled={!imageIdproofFront || !imageIdproofBack || !ImageTop || !ImageBottom || !ImageLeft || !ImageRight || !ImageFront || !ImageBack} type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Continue'} onClick={() => { setActiveTab(3); dispatch(pageChange("Adjustment")) }} />
                                </div> :
                                <div className='d-flex flex-column gap-2'>
                                    <CustomButton type={'button'} btnClassName={'btn-light btn-lg w-lg'} iconClasssName={''} name={'Previous'} onClick={() => { setActiveTab(1); dispatch(pageChange("IMEIPage")) }} />
                                    <CustomButton disabled={!imageIdproofFront || !imageIdproofBack || !ImageTop || !ImageBottom || !ImageLeft || !ImageRight || !ImageFront || !ImageBack} type={'button'} btnClassName={'btn-success btn-lg w-lg'} iconClasssName={undefined} name={'Continue'} onClick={() => { setActiveTab(3); dispatch(pageChange("Adjustment")) }} />
                                </div>}
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default UploadImage
